import type { ErrorReporter } from '@wix/cli-error-reporting';
import type { BiLogger } from '@wix/cli-telemetry';
import type { Command } from '@commander-js/extra-typings';

interface CommandServices {
  errorReporter: ErrorReporter;
  biLogger: BiLogger;
}

declare function getRootCommand(
  services: CommandServices,
  cliVersion: string
): Promise<Command>;

type GetRootCommandFn = typeof getRootCommand;

export type { GetRootCommandFn, CommandServices };
export { getRootCommand };

export const NO_TTY_JSON_OUTPUT_OPTION = '--json';
